import React from "react";

import { default as LoadingSpinner } from "./Loader";

const sleep = (m: number) => new Promise((r) => setTimeout(r, m));

type ComponentType = React.ComponentClass | null;

interface IAsyncState {
  component: ComponentType;
}

export default function asyncComponent(
  importComponent: any,
  Loader = <LoadingSpinner />,
) {
  class AsyncComponent extends React.Component<any, IAsyncState> {
    constructor(props: any) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      await sleep(process.env.NODE_ENV === "development" ? 150 : 0);

      const { default: component } = await importComponent();

      this.setState({
        component: component,
      });
    }

    render() {
      const C: ComponentType = this.state.component;

      return C ? <C {...this.props} /> : Loader;
    }
  }

  return AsyncComponent;
}
